import React, { useState } from 'react'
import { Routes } from '../../../../constants/Routes'
import { IDuplicateList, IDuplicateObject } from '@getgreenline/homi-shared'
import { Alert, Popover } from 'antd'
import { capitalizeFirstLetter } from '../../../../utilities/helpers'

export interface Props {
  DuplicateProductsMap: IDuplicateList
  text: string
  DuplicateListKey?: 'sku' | 'barcode'
  hideKeyColumn?: boolean
}

export const DuplicateProductAlert = React.memo((props: Props) => {
  const { DuplicateProductsMap, text, DuplicateListKey, hideKeyColumn } = props
  const listEntryKeys = Object.keys(DuplicateProductsMap)

  return (
    <Alert
      className='gr-filter-item gr-filter-gutter duplicate-product-warning'
      type='warning'
      showIcon
      style={{ width: 350, marginRight: 5 }}
      message={
        <div className='d-flex'>
          <span style={{ flexGrow: 1 }}>
            {listEntryKeys.length} {text}
            {listEntryKeys.length > 1 ? 's' : ''}
          </span>
          <Popover
            trigger='click'
            placement='bottom'
            autoAdjustOverflow={false}
            content={
              <div style={{ maxHeight: 600, overflowY: 'scroll' }}>
                <table className='table table-sm'>
                  <thead className='thead-light'>
                    <tr>
                      {!hideKeyColumn && DuplicateListKey && (
                        <th>{capitalizeFirstLetter(DuplicateListKey)}</th>
                      )}
                      <th>Products</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listEntryKeys.map((key, index) => {
                      return (
                        <tr key={index}>
                          {!hideKeyColumn && <td style={{ whiteSpace: 'nowrap' }}>{key}</td>}
                          <td>
                            <ul>
                              {DuplicateProductsMap[key].map(
                                (product: IDuplicateObject, productIndex) => (
                                  <li key={DuplicateListKey + product.id + productIndex}>
                                    <a
                                      onClick={(e) => {
                                        const selection = document.getSelection()
                                        if (selection && selection.type !== 'Range') {
                                          window.open(
                                            `${Routes.EDIT_PRODUCT(
                                              product.companyId,
                                              product.parentProductId
                                                ? product.parentProductId
                                                : product.id,
                                              window.location.search,
                                            )}`,
                                            '_blank',
                                          )
                                        }
                                      }}
                                    >
                                      {product.name}
                                    </a>
                                  </li>
                                ),
                              )}
                            </ul>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            }
          >
            <a>See more</a>
          </Popover>
        </div>
      }
    />
  )
})
